import { render, staticRenderFns } from "./InsuranceKasko.vue?vue&type=template&id=9c61b650"
import script from "./InsuranceKasko.vue?vue&type=script&lang=js"
export * from "./InsuranceKasko.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports